export enum UserActionEntityType {
    Associations,
    Businesses,
    Products,
    BusinessOrders,
    BusinessProspects,
    BusinessKpis,
    UserInvitations,
    UserActionLogs,
    Services,
    BusinessBookingRequests,
    Users,
    BusinessContacts,
    SkuSerials,
    CampaignTracking,
    Posts,
    PlainPosts,
    FlashOffers,
    Events,
    UpdatePosts,
    FlashOffersBookingRequests
}
